<ng-container *ngIf="!hide">
  <mat-header-cell *matHeaderCellDef class="cell">
  </mat-header-cell>
  <mat-cell class="cell" [attr.colspan]="columnsLength">
    <span>
      {{'dashboard.common.board.noResultMessage' | translate}}
    </span>
  </mat-cell>
</ng-container>
